module.exports = __webpack_public_path__ + "static/group-1-b977e00a337455d617f0be5faa9016fc.jpg";